import 'react';
import { useState } from 'react';

import PartModelModal from '../../../components/PartModelViewer/PartModelModal.tsx';
import None from '../../../assets/none-icon.svg';
import { Lineitem } from '../../../interfaces/Ordel.Interface.ts';

interface Props {
	lineItem: Lineitem;
}

const Thumbnail = (props: Props) => {
	const [is3DModalOpen, setIs3DModalOpen] = useState(false);

	return (
		<>
			<div className="flex flex-col items-center">
				<img
					className="mb-2"
					style={{
						width: '100%',
						cursor:
							!props.lineItem.thumbnail_file && !props.lineItem.step_file
								? 'not-allowed'
								: 'pointer',
						border: !props.lineItem.thumbnail_file ? '1px solid #aaa' : 'none',
						opacity: props?.lineItem.thumbnail_file ? 1 : 0.25,
					}}
					src={
						props.lineItem.thumbnail_file ? props.lineItem.thumbnail_file : None
					}
					onClick={() =>
						props?.lineItem.file_3djs ? setIs3DModalOpen(true) : null
					}
				/>

				{!props.lineItem.thumbnail_file ? (
					<div className="mb-5">No Preview</div>
				) : null}
			</div>

			{props?.lineItem.file_3djs ? (
				<PartModelModal
					open={is3DModalOpen}
					url={props.lineItem.file_3djs}
					partName={props.lineItem.name}
					onClose={() => setIs3DModalOpen(false)}
				/>
			) : null}
		</>
	);
};

export default Thumbnail;
